var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6245 4.1875H3.5C2.752 4.1875 2 4.5 2 5.5V18.3633C1.97998 19.2773 2.5528 19.8125 3.5 19.8125H20.534C21.4273 19.8125 22 19.3371 22 18.4645V5.48438C22 4.75391 21.5386 4.1875 20.6245 4.1875ZM7.70312 18.25H3.5625V9.26562H7.70312V18.25ZM20.4375 18.25H9.26562V9.26562H20.4375V18.25ZM20.4375 7.70312H3.5625V5.75H20.4375V7.70312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.92353e67890a1641a91ffd4b4c5eeea2.svg";
export { ForwardRef as ReactComponent };